$('.vid-slider').slick({
    dots: false,
    infinite: true,
    speed: 600,
    arrows: true,
    slidesToShow: 1,           
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    prevArrow: '<img class="slick-prev" src="https://cdn.shopify.com/s/files/1/0033/6317/6560/files/prev.png?v=1653069562" alt="">',
    nextArrow: '<img class="slick-next" src="https://cdn.shopify.com/s/files/1/0033/6317/6560/files/next.png?v=1653069482" alt="">',
    responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,                
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,                
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,                
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});

$('.test-slid').slick({
  dots: false,
  infinite: true,
  speed: 600,
  arrows: false,   
  slidesToShow: 6,
  autoplay: true,
  autoplaySpeed: 2000,  
  slidesToScroll: 1,
  prevArrow: '<button type="button" class="slick-prev">Previous</button>',
  nextArrow: '<button type="button" class="slick-next">Next</button>',
  responsive: [{
          breakpoint: 1259,
          settings: {
              slidesToShow: 6,
              slidesToScroll: 1,
              infinite: true,
              dots: false
          }
      }, {
          breakpoint: 1024,
          settings: {
              slidesToShow: 6,
              slidesToScroll: 1,
              infinite: true,
              dots: false
          }
      },
      {
          breakpoint: 991,
          settings: {
              slidesToShow: 6,
              slidesToScroll: 1
          }
      },
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 6,
              slidesToScroll: 1
          }
      },
      {
          breakpoint: 480,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 1
          }
      }
  ]
});


document.querySelectorAll('.featured-pro-inner').forEach(function(carouselEl) {
  // Get the 'slide' attribute value and parse it as an integer
  var slideCount = parseInt(carouselEl.getAttribute('slide'));
  let center_padding = 0;
  if(slideCount == 1){
    center_padding = "30%";
  }
  else if(slideCount > 1){
    center_padding = "100px";
  }

  // Create settings with dynamic slidesToShow
  var settings = {
    dots: false,
    arrows: true, 
    slide: '.slick-slideshow__slide',
    slidesToShow: slideCount,
    centerMode: true,
    autoplaySpeed: 3000,
    centerPadding: center_padding,
    initialIndex: 0,
    cellAlign: 'left',
    contain: true,
    responsive: [
      {
        breakpoint: 1259,
        settings: {
          slidesToShow: slideCount,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: slideCount,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          centerPadding: '0'
        }
      }
    ]
  };

  var $carousel = $(carouselEl);
  $carousel.slick(settings);
  $carousel.slick('slickGoTo', 1);

  function setSlideVisibility() {
    var visibleSlides = $carousel.find('.slick-slideshow__slide[aria-hidden="false"]');
    visibleSlides.css('opacity', 1);
    visibleSlides.first().prev().css('opacity', 0);
  }
  setSlideVisibility();
  $carousel.on('afterChange', function() {
    setSlideVisibility();
  });
});


// var $carousel = $('.featured-pro-inner');
// let all_slider_main = document.querySelectorAll('.featured-pro-inner');
// console.log("all_slider_main --->", all_slider_main[2].getAttribute('slide'));


// var settings = {
//   dots: false,
//   arrows: true, 
//   slide: '.slick-slideshow__slide',
//   slidesToShow: 2,
//   centerMode: true,
//   // autoplay: true,
//   autoplaySpeed: 3000,
//   centerPadding: '150px',
  
//   responsive: [{
//     breakpoint: 1259,
//     settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         infinite: true,
//         dots: false
//     }
// }, {
//     breakpoint: 1024,
//     settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         infinite: true,
//         dots: false
//     }
// },
// {
//     breakpoint: 991,
//     settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//     }
// },
// {
//     breakpoint: 800,
//     settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         dots: true
//     }
// },
// {
//   breakpoint: 600,
//   settings: {
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       dots: true
//   }
// },
// {
//     breakpoint: 480,
//     settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         dots: true
//     }
// }
// ]
// };

// function setSlideVisibility() {
//   //Find the visible slides i.e. where aria-hidden="false"
//   var visibleSlides = $carousel.find('.slick-slideshow__slide[aria-hidden="false"]');
//   //Make sure all of the visible slides have an opacity of 1
//   $(visibleSlides).each(function() {
//     $(this).css('opacity', 1);
//   });

//   //Set the opacity of the first and last partial slides.
//   $(visibleSlides).first().prev().css('opacity', 0);
// }

// $carousel.slick(settings);
// $carousel.slick('slickGoTo', 1);
// setSlideVisibility();
 
// $carousel.on('afterChange', function() {
//   setSlideVisibility();
// });

// FULL SIZED SLIDER
var $carousel = $('.featured-pro-full');

var settings = {
  dots: true,
  arrows: false, 
  slide: '.slick-slideshow__slide',
  slidesToShow: 4,
  centerMode: false,
  autoplay: false,
  autoplaySpeed: 3000,
  centerPadding: '200px',
  
  responsive: [{
    breakpoint: 1259,
    settings: {
        slidesToShow: 3,
        slidesToScroll:1,
        infinite: true,
        dots: true
    }
}, {
    breakpoint: 1024,
    settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
    }
},
{
    breakpoint: 991,
    settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true
    }
},
{
    breakpoint: 800,
    settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true
    }
},
{
  breakpoint: 600,
  settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true
  }
},
{
    breakpoint: 480,
    settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
    }
}
]
};

function setSlideVisibility() {
  //Find the visible slides i.e. where aria-hidden="false"
  var visibleSlides = $carousel.find('.slick-slideshow__slide[aria-hidden="false"]');
  //Make sure all of the visible slides have an opacity of 1
  $(visibleSlides).each(function() {
    $(this).css('opacity', 1);
  });

  //Set the opacity of the first and last partial slides.
  $(visibleSlides).first().prev().css('opacity', 0);
}

$carousel.slick(settings);
//$carousel.slick('slickGoTo', 1);
setSlideVisibility();
 
$carousel.on('afterChange', function() {
  setSlideVisibility();
});

// REVIEW SLIDER 
var $carousel = $('.rev-pro-inner');

var settings = {
  dots: false,
  arrows: true,
  slide: '.slick-slideshow__slide',
  slidesToShow: 1,
  centerMode: true,
  autoplay: true,
    autoplaySpeed: 4000,
  centerPadding: '200px',
  
  responsive: [{
    breakpoint: 1259,
    settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
    }
}, {
    breakpoint: 1024,
    settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
    }
},
{
    breakpoint: 991,
    settings: {
        slidesToShow: 1,
        slidesToScroll: 1
    }
},
{
    breakpoint: 800,
    settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
    }
},
{
  breakpoint: 600,
  settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true
  }
},
{
    breakpoint: 480,
    settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
    }
}
]
};

function setSlideVisibility() {
  //Find the visible slides i.e. where aria-hidden="false"
  var visibleSlides = $carousel.find('.slick-slideshow__slide[aria-hidden="false"]');
  //Make sure all of the visible slides have an opacity of 1
  $(visibleSlides).each(function() {
    $(this).css('opacity', 1);
  });

  //Set the opacity of the first and last partial slides.
  $(visibleSlides).first().prev().css('opacity', 0);
}

$carousel.slick(settings);
$carousel.slick('slickGoTo', 1);
setSlideVisibility();
 
$carousel.on('afterChange', function() {
  setSlideVisibility();
});

// ON CLICK ADD CLASS
$(document).ready(function(){
  $(document).on('click','.carousel .carousel-cell.is-selected .image-wrapper', function(){
    $(this).first('div').toggleClass('d-none');
  })
});

$(document).ready(function(){
  $(document).on('click','.carousel .carousel-cell.is-selected .image-wrapper', function(){
    $(this).next('div').toggleClass('show');
  })
});


// $('li.mobile-menu__list-item').on('click', function(e) {
//     e.preventDefault(); 
//    var a = $(this).toggleClass('active');
//    console.log(a);
// });

// Sidebar

  $(document).ready(function(){
  $('.side-m').click( function() {
    $(".sidebar-section").addClass("d-expand");
})
} );

$(document).ready(function(){
    $('.closebtn.d-none').click( function() {
      $(".sidebar-section").removeClass("d-expand");
  })
  } );



  $(document).ready(function(){
    $(document).on('click','.submenu__label', function(){
      $(this).toggleClass('m-menu');
    })
  });

$(document).ready(function() {
    $('[data-mce-fragment], [data-mce-style]').each(function() {
        $(this).removeAttr('data-mce-fragment');
        $(this).removeAttr('data-mce-style');
    });
});